import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import KendoReactDropDownTree from './KendoReactDropDownTree';

export const KendoReactDropDownTreeBridge = react2angular(
  KendoReactDropDownTree,
  [
    'id',
    'dataTestid',
    'categories',
    'categoryClicked',
    'selectedIndex',
    'selectedId',
    'className',
    'dataItemKey',
    'textField',
    'subItemsField',
    'placeholder',
    'defaultItemId',
    'disabled',
    'showFilter',
    'filterThreshold'
  ]
);
